export default __webpack_public_path__ + "static/media/authentication-bg.cf5de3dd.svg";